export default {
  data () {
    return {
      time: 0,
      btnDisabled: false,
      intervalTimer: null,
      btnText: '下一题',
      tempBtnText: ''
    }
  },
  methods: {
    countDown () {
      this.time -= 1
      this.btnDisabled = true
      this.btnText = `${this.tempBtnText} (${this.time}s)`
      if (this.time < 0) {
        this.btnDisabled = false
        this.btnText = this.tempBtnText
        if (this.countDownEnd) this.countDownEnd()
        clearInterval(this.intervalTimer)
      }
    },
    // 开始倒计时
    startCountDown (time = 15, btnText = '下一题') {
      this.time = time
      this.btnText = btnText
      this.tempBtnText = this.btnText
      this.intervalTimer = setInterval(this.countDown, 1000)
    }
  },
  filters: {
    filterSelectText (val) {
      switch (val) {
        case 0:
          return 'A'
        case 1:
          return 'B'
        case 2:
          return 'C'
        case 3:
          return 'D'
        default:
          return ''
      }
    }
  },
  beforeDestroy () {
    if (this.intervalTimer) clearInterval(this.intervalTimer)
  }
}
